module.exports = __webpack_public_path__ + "static/media/HCMM595.b23bc8d9.jpg";